import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import type { IUserNameFormOutput } from '@app/auth/models/username-form-output-model';
import { OtpInputComponent } from '@shared/components/otp-input/otp-input.component';
import { AuthViewEnum } from '../../enums/auth-step-enum';
import { interval, Subscription, takeWhile, tap } from 'rxjs';
import { CounterPipe } from "../../../../../shared/pipes/counter/counter.pipe";
import { ButtonLoaderDirective } from '@shared/directive/button-loader/button-loader.directive';

@Component({
    selector: 'app-otp-verification-presenter',
    imports: [
        OtpInputComponent,
        ButtonLoaderDirective,
        CounterPipe
    ],
    templateUrl: './otp-verification-presenter.component.html',
    styleUrl: './otp-verification-presenter.component.scss'
})
export class OtpVerificationPresenterComponent implements OnInit , OnDestroy {

  code = '';
  countdown$!: Subscription;
  countdown = 90;
  @Input() verifyLoading = false;
  @Input() initialData: IUserNameFormOutput | null = null;
  @Output() onCodeChanged = new EventEmitter<string>();
  @Output() onLoginWithPasswordDesired: EventEmitter<AuthViewEnum> = new EventEmitter<AuthViewEnum>();
  @Output() onResetAuthFlow = new EventEmitter<void>();
  @Output() onRequestOtp: EventEmitter<IUserNameFormOutput> = new EventEmitter<IUserNameFormOutput>();

  ngOnInit(): void {
    this.startCountDown()
  }

  changeUserName() {
    this.onResetAuthFlow.emit();
  }

  verifyCode(code?: string) {
    if (code)
      this.code = code;
    if (this.code && this.code?.length == 4) {
      this.onCodeChanged.emit(this.code);
    }
  }

  requestOtpCodeAgainHandler() {
    this.onRequestOtp.emit(this.initialData!);
    this.startCountDown();
  }

  private startCountDown() {
    if (this.countdown$) {
      this.countdown$.unsubscribe();
    }

    this.countdown = 90;
    this.countdown$ = interval(1000).pipe(
      takeWhile(() => this.countdown > 0),
      tap(() => {
          this.countdown--;
      }),
    ).subscribe();

  }

  loginWithPassword() {
    this.onLoginWithPasswordDesired.emit(AuthViewEnum.login);
  }

  ngOnDestroy(): void {
    this.countdown$.unsubscribe()
  }



}
